<template lang="pug">
  div(v-if="followUp")
    template(v-if="isEmailSent")
      RouterLink(:to=" '/tours/' + tour.id + '/follow-up'")
        Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-check-circle" severity="secondary" v-tooltip.top="'Follow Up'")
    template(v-else-if="isApproved")
      RouterLink(:to=" '/tours/' + tour.id + '/follow-up'")
        Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-check" severity="secondary" v-tooltip.top="'Follow Up'")
    template(v-else)
      RouterLink(:to=" '/tours/' + tour.id + '/follow-up'")
        Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-eye" severity="warn" v-tooltip.top="'Follow Up'")
  div(v-else-if="showFollowUpButton")
    RouterLink(:to=" '/tours/' + tour.id + '/follow-up'")
      Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-arrow-counter-clockwise" severity="info" v-tooltip.top="'Follow Up'")
</template>

<script setup>
import { useAttrs, computed } from 'vue'

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  tour: { type: Object, default: {} },
  showLabel: { type: Boolean, default: true },
})

const attrs   = useAttrs()

const followUp        = computed(() => props.tour.followUp)
const isApproved      = computed(() => followUp.value?.isApproved)
const isEmailSent     = computed(() => followUp.value?.emailStatus?.status === 'sent')
const showFollowUpButton = computed(() => props.tour['showFollowUpButton?'])

const label = computed(() => {
  if (!props.showLabel) return null

  if (followUp.value) {
    if (isEmailSent.value)  return 'Sent'
    if (isApproved.value)   return 'Approved'
    return 'Pending'
  }
  return 'Follow Up'
})
</script>
